import { EmulatorType } from '@localstack/types';

import { AppRoute } from '~/config';
import { EMULATORS, OfferedEmulator } from '~/views/customer/PricingPlans/components/planFamilies';

export const EMULATOR_QUERY_PARAM = 'emulator';
export const SHOW_TABS_QUERY_PARAM = 'showTabs';
export const SUBSCRIPTION_QUERY_PARAM = 'subscription';

/** Only an emulator we offer is a valid product to land on, whatever the URL says. */
export const parseEmulatorParam = (raw: string | null): OfferedEmulator | null =>
  EMULATORS.find((emulator) => emulator === raw) ?? null;

export const pricingRoute = (emulators: EmulatorType[] = [], subscriptionId?: string): string => {
  const emulator = emulators.length === 1 ? emulators[0] : undefined;

  // Several emulators, or none, means the intent is unknown: preselect AWS but let the
  // user switch products rather than deciding for them.
  const params = new URLSearchParams(
    emulator
      ? { [EMULATOR_QUERY_PARAM]: emulator }
      : { [EMULATOR_QUERY_PARAM]: EmulatorType.AWS, [SHOW_TABS_QUERY_PARAM]: 'true' },
  );

  if (subscriptionId) {
    params.set(SUBSCRIPTION_QUERY_PARAM, subscriptionId);
  }

  return `${AppRoute.PRICING}?${params.toString()}`;
};
